import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="application--form"
export default class extends Controller {
  static targets = [
    "submitButton"
  ]

  submit(_) {
    this.submitButtonTarget.disabled = true

    this.element.requestSubmit()
  }
}
